import { takeLatest } from 'redux-saga';
import http from './../_utils/httpSaga';
import { put } from 'redux-saga/effects';

import {
  FETCH_UPDATES,
  fetchUpdatesSuccess,
  fetchUpdatesFailure
} from './actions';


function* fetchUpdates({parent}) {
  let result = yield http.json.get(`/api/skiresort/${parent.id}/changes`);
  if (result instanceof Error) {
    yield put(fetchUpdatesFailure(result));
  } else {
    yield put(fetchUpdatesSuccess(result));
  }
}

export default function*() {
  yield [
    takeLatest(FETCH_UPDATES.do, fetchUpdates)
  ];
}



// WEBPACK FOOTER //
// ./src/redux/updates/saga.js